import { Element } from 'react';

import CommentNodeModel from '../CommentNodeModel';
import CommentNodeWidget from '../CommentNodeWidget';

import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import { DiagramEngine } from '@projectstorm/react-diagrams-core';

export default class CommentNodeFactory extends AbstractReactFactory<CommentNodeModel, DiagramEngine> {
  constructor() {
    super("NGComment");
  }

  generateReactWidget = (e): Element => (
    <CommentNodeWidget
        commentId={e.model.options.commentId}
        engine={this.engine} 
        node={e.model}
    />
  )

  generateModel = commentId => new CommentNodeModel(commentId);
}
